var _excluded = ["subscriberPaymentInstrument"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import i18n from 'invision-core/src/components/i18n/i18n';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import MetadataActions from 'invision-core/src/components/metadata/metadata.actions';
import MetadataConstants from 'invision-core/src/components/metadata/metadata.constants';
import MetadataSelectors from 'invision-core/src/components/metadata/metadata.selectors';
import { getUpperLimitAccess, hasAccess } from 'invision-core/src/components/security/permission.service';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import { RIGHT_ALIGNED_HEADER_TEMPLATE } from 'invision-ui/lib/components/collections/datatable/cellTemplates/cellTemplates';
import clone from 'ramda/src/clone';
import path from 'ramda/src/path';
import pathOr from 'ramda/src/pathOr';
import pluck from 'ramda/src/pluck';
import uniq from 'ramda/src/uniq';
import { stateGo } from 'redux-ui-router';
import { NOTIFICATION_TIME_LENGTH, TRANSACTION_ITEM_TYPE, TRANSACTION_STATUS, TRANSACTION_TYPE } from '../../../../customercare.constants';
import { DASHBOARD_ROUTE } from '../../../../reducers/constants/dashboard.constants';
import { BLANK_PAYMENT_INSTRUMENT } from '../../makePayment/make.payment.constants';
import { SessionSelectors } from 'invision-core';
import { CurrentBusinessUnitCurrencyCodeSelector, IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import CustomerLocaleKeys from '../../../../locales/keys';
import { transactionDetails } from '../../../../print';
import { RETRY_ACTIVATION_PAYMENT_STATE_REDIRECT } from '../../../../reactRoutes';
import { retrieveConvergentBillerSubscriberSummary } from '../../../../reducers/actions/customer.convergent.biller.actions';
import { renewOffCycleCharges, retrieveAvailablePaymentInstrumentTypes, retrieveWallet, updateOfferingInstancePaymentInstrument } from '../../../../reducers/actions/customer.ewallet.actions';
import { emailTransaction, retrieveTransaction } from '../../../../reducers/actions/customer.transactions.actions';
import { CHARGE_TIMING } from '../../../../reducers/constants/wizard.constants';
import { CanApplyCreditSelector, CanChangePaymentInstrument, MutablePaymentInstrumentsTypeFilterOptionsSelector } from '../../../../reducers/selectors/apply.credit.modal.selectors';
import { ConsolidatedCosPaymentHandlingFeatureToggleSelector, DisplayTransactionEmailAndPrintFeatureToggleSelector, HideTransactionItemsFeatureToggleSelector } from '../../../../reducers/selectors/customer.actions.template.selectors';
import { ConvergentBillerSubscriberOfferingSummariesSelector, CurrentAccountSummarySelector } from '../../../../reducers/selectors/customer.convergent.biller.selectors';
import { MutablePaymentInstrumentsSelector, PaymentInstrumentsSelector } from '../../../../reducers/selectors/customer.ewallet.selectors';
import { CanRetryTransactionSelector, CurrentTransactionDetailsPurchaseOrderItemsSelector, CurrentTransactionDetailsSelector, CurrentTransactionIdSelector, IsEligibleForPartialRefundsSelector, IsFetchingDataSelector, MutableTransactionDetailPaymentInstruments, PrintTransactionDetailsSelector, getPurchaseOrderItemTypeTooltip as _getPurchaseOrderItemTypeTooltip, shouldLinkPurchaseOrderItemTypeRow } from '../../../../reducers/selectors/customer.transactions.selectors';
import { ISSUE_CREDIT_STANDARD_CURRENCY_LIMIT, ISSUE_CREDIT_TO_ALTERNATE_PAYMENT_INSTRUMENT, ISSUE_WRITE_OFF, SEND_TRANSACTION_RECEIPT_ACCESS } from '../../../../security.attributes';
import { MENU_ITEMS } from '../../dashboard/dbssDashboard/dashboard.constants';
import { SERVICES_AND_SHARED_ENTITLEMENTS } from '../../servicesAndUsage/services.and.usage.config';
import { SERVICE_USAGE_DETAILS_STATE_NAME } from '../../servicesAndUsage/usageDetails/usage.details.config';
import { LIST_STATE_OR_NAME, TRANSACTION_DETAILS_STATE } from '../transactions.config';
import { transactionTypeNameIdentifier } from '../transactions.helpers';
import { CurrentCustomerCurrencyCodeSelector, CurrentCustomerIdSelector, IsPIIDataAccessEnabledSelector, RouteParams, RoutePreviousState } from './../../../../reducers/selectors/customer.selectors';
var MORE_OPTIONS_IDENTIFIER = {
  WRITE_OFF: 0,
  PRINT: 1,
  EMAIL: 2,
  APPLY_CREDIT: 3
};
var PAYMENT_SUCCESS_RESULT_CODE = 0;
var orderDetailsRoute = 'index.customercare.customer.orderHistory.details';
var DetailController = /*#__PURE__*/function () {
  function DetailController($window, $ngRedux, $timeout, uiNotificationService, $state) {
    _classCallCheck(this, DetailController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $state: $state,
      $timeout: $timeout,
      $window: $window,
      backButtonText: '',
      closeChangePaymentMethodPopup: this.closeChangePaymentMethodPopup.bind(this),
      closeCreditRefundModal: this.closeCreditRefundModal.bind(this),
      CustomerLocaleKeys: CustomerLocaleKeys,
      hasRetryActivationPayment: false,
      isModifyPaymentMethodPopupShown: false,
      moreOptionsArray: [],
      onBannerClose: this.onBannerClose.bind(this),
      onChangePaymentMethod: this.onChangePaymentMethod.bind(this),
      onCloseModifyPaymentMethodPopup: this.onCloseModifyPaymentMethodPopup.bind(this),
      openStatementDetails: this.openStatementDetails.bind(this),
      onSuccessModifyPaymentMethodPopup: this.onSuccessModifyPaymentMethodPopup.bind(this),
      shouldLinkPurchaseOrderItemType: this.shouldLinkPurchaseOrderItemType.bind(this),
      shouldShowBackBanner: false,
      showCreditRefundModal: false,
      transactionDetailsForRetryPayment: {},
      transactionTypeNameIdentifier: transactionTypeNameIdentifier,
      TRANSACTION_TYPE: TRANSACTION_TYPE,
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(DetailController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.transactionItemColumns = [{
        field: 'TransactedDate',
        cellTemplate: require('./cellTemplates/transaction/date.html'),
        displayName: i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.TRANSACTED_DATE),
        minWidth: 70,
        manWidth: 100,
        enableColumnResizing: true
      }, {
        field: 'TypeName',
        displayName: i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.TYPE),
        cellTemplate: require('./cellTemplates/transaction/type.html'),
        enableColumnResizing: true,
        minWidth: 120
      }, {
        field: 'TransactionTypeName',
        displayName: i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.ITEM_TYPE),
        cellTemplate: require('./cellTemplates/transaction/item.type.html'),
        enableColumnResizing: true,
        minWidth: 120
      }, {
        field: 'ResultCode',
        displayName: i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.RESULT),
        cellTemplate: require('./cellTemplates/transaction/result.html'),
        minWidth: 70,
        enableColumnResizing: true
      }, {
        field: 'Amount',
        displayName: i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.AMOUNT),
        cellTemplate: require('./cellTemplates/transaction/amount.html'),
        enableColumnResizing: true,
        headerCellClass: 'u-pr++',
        headerCellTemplate: RIGHT_ALIGNED_HEADER_TEMPLATE,
        minWidth: 100
      }];
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          adjustmentReasonOptions: MetadataSelectors.codes.MetadataOptionsForCodeValuesSelector(MetadataConstants.codes.BalanceAdjustmentReason, store),
          adjustmentReasonsLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.BalanceAdjustmentReason, store),
          canApplyCredit: CanApplyCreditSelector(store),
          canChangePaymentInstrument: CanChangePaymentInstrument(store),
          canRetryTransaction: CanRetryTransactionSelector(store),
          convergentBillerSubscriberOfferingSummaries: ConvergentBillerSubscriberOfferingSummariesSelector(store),
          creditReasonsLoaded: MetadataSelectors.codes.CreditReasonsLoadedSelector(store),
          currentAccountSummary: CurrentAccountSummarySelector(store),
          currentBusinessUnitCurrencyCode: CurrentBusinessUnitCurrencyCodeSelector(store),
          currentCustomerCurrencyCode: CurrentCustomerCurrencyCodeSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          currentTransactionDetails: CurrentTransactionDetailsSelector(store),
          currentTransactionId: CurrentTransactionIdSelector(store),
          ewalletPaymentInstruments: PaymentInstrumentsSelector(store),
          mutableEwalletPaymentInstruments: MutablePaymentInstrumentsSelector(store),
          featureTogglesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(CODES.FeatureToggleConfig, store),
          isBusinessUnitTemplateLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(CODES.BusinessUnitTemplate, store),
          isConsolidatedCosPaymentHandlingEnabled: ConsolidatedCosPaymentHandlingFeatureToggleSelector(store),
          isDbss: IsDbss(store),
          isDisplayTransactionEmailAndPrintEnabled: DisplayTransactionEmailAndPrintFeatureToggleSelector(store),
          isEligibleForPartialRefunds: IsEligibleForPartialRefundsSelector(store),
          isFetchingData: IsFetchingDataSelector(store),
          isHideTransactionItemsEnabled: HideTransactionItemsFeatureToggleSelector(store),
          isPIIDataAccessEnabled: IsPIIDataAccessEnabledSelector(store),
          isPosPaymentTypeLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.PointOfSalePaymentType, store),
          lastRoute: SessionSelectors.LastRouteSelector(store),
          mutableTransactionDetailPaymentInstruments: MutableTransactionDetailPaymentInstruments(store),
          paymentInstrumentsTypeFilterOptions: MutablePaymentInstrumentsTypeFilterOptionsSelector(store),
          paypalPaymentTypeLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.PaypalPaymentType, store),
          paypalPaymentTypes: MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.PaypalPaymentType, store),
          posPaymentTypes: MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.PointOfSalePaymentType, store),
          printTransactionDetails: PrintTransactionDetailsSelector(store),
          purchaseOrderItems: CurrentTransactionDetailsPurchaseOrderItemsSelector(store),
          reasonOptions: MetadataSelectors.codes.MetadataOptionsForCodeValuesSelector(MetadataConstants.codes.CreditReasons, store),
          routeParams: RouteParams(store),
          routePreviousState: RoutePreviousState(store),
          userSecurityAttributes: UserSecurityAttributesSelector(store)
        };
      };
      var controllerActions = {
        emailTransaction: emailTransaction,
        fetchAdjustmentReasons: MetadataActions.codes.fetchAdjustmentReasons,
        fetchCodeType: MetadataActions.codes.fetchCodeTypes,
        fetchCreditReasons: MetadataActions.codes.fetchCreditReasons,
        renewOffCycleCharges: renewOffCycleCharges,
        retrieveAvailablePaymentInstrumentTypes: retrieveAvailablePaymentInstrumentTypes,
        retrieveConvergentBillerSubscriberSummary: retrieveConvergentBillerSubscriberSummary,
        retrieveTransaction: retrieveTransaction,
        retrieveWallet: retrieveWallet,
        stateGo: stateGo,
        updateOfferingInstancePaymentInstrument: updateOfferingInstancePaymentInstrument
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.stateOrName = this.state.currentRoute;
      this.dashboardRoute = DASHBOARD_ROUTE;
      this.DEFAULT_BACK_ROUTE = LIST_STATE_OR_NAME;
      this.optionalParams = {
        customerId: this.state.currentCustomerId
      };
      if (!this.state.currentTransactionDetails) {
        this.retrieveTransaction();
      }
      if (!this.state.paypalPaymentTypeLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.PaypalPaymentType);
      }
      if (!this.state.isPosPaymentTypeLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.PointOfSalePaymentType);
      }
      if (!this.state.featureTogglesLoaded) {
        this.actions.fetchCodeType(CODES.FeatureToggleConfig);
      }
      if (!this.state.isBusinessUnitTemplateLoaded) {
        this.actions.fetchCodeType(CODES.BusinessUnitTemplate);
      }
      if (!this.state.creditReasonsLoaded) {
        this.actions.fetchCreditReasons();
      }
      if (!this.state.adjustmentReasonsLoaded) {
        this.actions.fetchAdjustmentReasons();
      }
      this.transactionTypePopupConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this.transactionTypePopupApi = api;
        }
      };
      this.changePaymentPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref2) {
          var api = _ref2.api;
          _this.changePaymentPopupApi = api;
        }
      };
      this.modifyPaymentMethodPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref3) {
          var api = _ref3.api;
          _this.modifyPaymentMethodPopupApi = api;
        }
      };
      this.writeOffPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref4) {
          var api = _ref4.api;
          _this.writeOffPopupApi = api;
        }
      };
      this.applyCreditModalConfig = {
        onRegisterApi: function onRegisterApi(_ref5) {
          var api = _ref5.api;
          _this.applyCreditModalApi = api;
        }
      };
      this.applyCreditRefundModalConfig = {
        onRegisterApi: function onRegisterApi(_ref6) {
          var api = _ref6.api;
          _this.applyCreditRefundModalApi = api;
        }
      };
      this.emailPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref7) {
          var api = _ref7.api;
          _this.emailPopupApi = api;
        }
      };
      if (this.state.routePreviousState.name.match(orderDetailsRoute) !== null) {
        this.shouldShowBackBanner = true;
        this.backButtonText = i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.RETURN_TO_ORDER_DETAILS);
      } else if (this.state.routePreviousState.name.match(SERVICES_AND_SHARED_ENTITLEMENTS) !== null) {
        this.shouldShowBackBanner = true;
        this.backButtonText = i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.RETURN_TO_SHARED_ENTITLEMENTS);
      } else if (this.state.routeParams && this.state.routeParams.orderId) {
        // This logic is required when coming from react order details page to show back banner
        this.shouldShowBackBanner = true;
        this.backButtonText = i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.RETURN_TO_ORDER_DETAILS);
        this.previousRoute = {
          name: orderDetailsRoute,
          params: {
            orderId: this.state.routeParams.orderId
          }
        };
      }
      this.actions.retrieveAvailablePaymentInstrumentTypes({
        Currency: this.state.currentCustomerCurrencyCode || this.state.currentBusinessUnitCurrencyCode
      }).catch(function (error) {
        _this.uiNotificationService.transientError(error.translatedMessage);
      });
      if (this.state.isDbss) {
        this.actions.retrieveConvergentBillerSubscriberSummary(this.state.currentCustomerId, true).catch(function (error) {
          _this.uiNotificationService.transientError(error.translatedMessage);
        });
      }
      this.moreOptions();
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "retrieveTransaction",
    value: function retrieveTransaction() {
      var _this2 = this;
      this.actions.retrieveTransaction(this.state.currentTransactionId, this.state.currentCustomerId, this.state.isDbss).then(function () {
        _this2.isGracePeriodPaymentFailure = _this2.state.canRetryTransaction;
        _this2.failedCapturedTransactionItem = pathOr([], ['Items'], _this2.state.currentTransactionDetails).find(function (transactionItem) {
          return transactionItem ? transactionItem.ResultCode !== PAYMENT_SUCCESS_RESULT_CODE && transactionItem.TransactionType === TRANSACTION_ITEM_TYPE.CAPTURE : null;
        });
        _this2.moreOptions();
      }).catch(function () {
        _this2.uiNotificationService.transientError(i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.REVENUE_TRANSACTION_NOT_FOUND));
      });
    }
  }, {
    key: "getTransactionTypeName",
    value: function getTransactionTypeName() {
      if (this.state.currentTransactionDetails) {
        switch (this.state.currentTransactionDetails.Type) {
          case TRANSACTION_TYPE.ALA_CARTE:
            return i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.ALA_CARTE);
          case TRANSACTION_TYPE.BATCH_PAYMENT:
            return i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.BATCH_PAYMENT);
          case TRANSACTION_TYPE.BILL_PAY:
            return i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.BILL_PAY);
          case TRANSACTION_TYPE.ORDER_PROCESSING:
            return i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.ORDER_PROCESSING);
          case TRANSACTION_TYPE.PAYMENT_INSTRUMENT_DEPOSIT:
            return i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.PAYMENT_INSTRUMENT_DEPOSIT);
          case TRANSACTION_TYPE.PAYMENT_INSTRUMENT_CHARGE:
            return i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.PAYMENT_INSTRUMENT_CHARGE);
          case TRANSACTION_TYPE.PAYMENT_INSTRUMENT_VALIDATION:
            return i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.PAYMENT_INSTRUMENT_VALIDATION);
          case TRANSACTION_TYPE.REFUND:
            return i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.REFUND);
          case TRANSACTION_TYPE.RENEWAL:
            return i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.RENEWAL);
          case TRANSACTION_TYPE.SUBSCRIPTION_FEES:
            return i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.SUBSCRIPTION_FEE);
          case TRANSACTION_TYPE.EXTERNAL_DEPOSIT:
            return i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.EXTERNAL_DEPOSIT);
          case TRANSACTION_TYPE.USAGE_PAYMENT:
            return i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.USAGE_PAYMENT);
          default:
            break;
        }
      }
    }
  }, {
    key: "openStatementDetails",
    value: function openStatementDetails() {
      var _this$state$currentTr, _this$state$currentTr2, _this$state$currentTr3, _this$state$currentTr4, _this$state$currentTr5, _this$state$currentTr6, _this$state$currentTr7, _this$state$currentTr8, _this$state$currentTr9, _this$state$currentTr10;
      this.actions.stateGo(SERVICE_USAGE_DETAILS_STATE_NAME, {
        customerId: this.state.currentCustomerId,
        statementId: this.state.currentTransactionDetails.ExternalReference,
        serviceIdentifierValue: (_this$state$currentTr = this.state.currentTransactionDetails.PurchaseOrder) === null || _this$state$currentTr === void 0 ? void 0 : (_this$state$currentTr2 = _this$state$currentTr.Items) === null || _this$state$currentTr2 === void 0 ? void 0 : (_this$state$currentTr3 = _this$state$currentTr2[0]) === null || _this$state$currentTr3 === void 0 ? void 0 : (_this$state$currentTr4 = _this$state$currentTr3.PurchaseInformation) === null || _this$state$currentTr4 === void 0 ? void 0 : (_this$state$currentTr5 = _this$state$currentTr4.ServiceIdentifier) === null || _this$state$currentTr5 === void 0 ? void 0 : _this$state$currentTr5.Value,
        serviceAttributeId: (_this$state$currentTr6 = this.state.currentTransactionDetails.PurchaseOrder) === null || _this$state$currentTr6 === void 0 ? void 0 : (_this$state$currentTr7 = _this$state$currentTr6.Items) === null || _this$state$currentTr7 === void 0 ? void 0 : (_this$state$currentTr8 = _this$state$currentTr7[0]) === null || _this$state$currentTr8 === void 0 ? void 0 : (_this$state$currentTr9 = _this$state$currentTr8.PurchaseInformation) === null || _this$state$currentTr9 === void 0 ? void 0 : (_this$state$currentTr10 = _this$state$currentTr9.ServiceIdentifier) === null || _this$state$currentTr10 === void 0 ? void 0 : _this$state$currentTr10.ServiceAttributeId,
        tab: 'usage',
        searchBy: 'UsageStatementId',
        allEntitlements: true
      });
    }
  }, {
    key: "onMoreItemSelected",
    value: function onMoreItemSelected(item) {
      switch (item.id) {
        case MENU_ITEMS.ADD_PAYMENT_INSTRUMENT:
          this.openPaymentMethodPopup(false);
          break;
        case MENU_ITEMS.EDIT_PAYMENT_INSTRUMENT:
          this.openPaymentMethodPopup(true);
          break;
        case MENU_ITEMS.CHANGE_PAYMENT_INSTRUMENT:
          this.openChangePaymentMethodPopup();
          break;
        default:
          break;
      }
    }
  }, {
    key: "shouldLinkPurchaseOrderItemType",
    value: function shouldLinkPurchaseOrderItemType(row) {
      return shouldLinkPurchaseOrderItemTypeRow({
        referenceTransactionId: row.referenceTransactionId,
        isConsolidatedCosPaymentHandlingEnabled: this.state.isConsolidatedCosPaymentHandlingEnabled
      });
    }
  }, {
    key: "getPurchaseOrderItemTypeTooltip",
    value: function getPurchaseOrderItemTypeTooltip(row) {
      return _getPurchaseOrderItemTypeTooltip({
        referenceTransactionId: row.referenceTransactionId,
        isAppliedItem: !!row.isAppliedItem,
        isConsolidatedCosPaymentHandlingEnabled: this.state.isConsolidatedCosPaymentHandlingEnabled
      });
    }
  }, {
    key: "getItemTypeName",
    value: function getItemTypeName(item) {
      switch (item.TransactionType) {
        case TRANSACTION_ITEM_TYPE.AUTHORIZATION_REVERSAL:
          return i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.TRANSACTION_ITEM_TYPE.AUTHORIZATION_REVERSAL);
        case TRANSACTION_ITEM_TYPE.CAPTURE:
          return i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.TRANSACTION_ITEM_TYPE.CAPTURE);
        case TRANSACTION_ITEM_TYPE.CREDIT:
          return i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.TRANSACTION_ITEM_TYPE.CREDIT);
        case TRANSACTION_ITEM_TYPE.DEPOSIT:
          return i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.TRANSACTION_ITEM_TYPE.DEPOSIT);
        case TRANSACTION_ITEM_TYPE.SALE:
          return i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.TRANSACTION_ITEM_TYPE.SALE);
        case TRANSACTION_ITEM_TYPE.VOIDED_CREDIT:
          return i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.TRANSACTION_ITEM_TYPE.VOIDED_CREDIT);
        case TRANSACTION_ITEM_TYPE.VOIDED_DEPOSIT:
          return i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.TRANSACTION_ITEM_TYPE.VOIDED_DEPOSIT);
        case TRANSACTION_ITEM_TYPE.VOIDED_SALE:
          return i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.TRANSACTION_ITEM_TYPE.VOIDED_SALE);
        case TRANSACTION_ITEM_TYPE.WRITE_OFF:
          return i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.TRANSACTION_ITEM_TYPE.WRITE_OFF);
        case TRANSACTION_ITEM_TYPE.WRITE_OFF_REVERSAL:
          return i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.TRANSACTION_ITEM_TYPE.WRITE_OFF_REVERSAL);
        case TRANSACTION_ITEM_TYPE.AUTHORIZATION:
          return i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.TRANSACTION_ITEM_TYPE.AUTHORIZATION);
        case TRANSACTION_ITEM_TYPE.NO_PROCESSING:
          return i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.TRANSACTION_ITEM_TYPE.NO_PROCESSING);
        default:
          break;
      }
    }
  }, {
    key: "getTransactionStatus",
    value: function getTransactionStatus(status) {
      switch (status) {
        case TRANSACTION_STATUS.OPEN:
          return i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.OPEN);
        case TRANSACTION_STATUS.COMPLETE:
          return i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.COMPLETE);
        case TRANSACTION_STATUS.SCHEDULE:
          return i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.SCHEDULE);
        default:
          break;
      }
    }
  }, {
    key: "handleOptionSelected",
    value: function handleOptionSelected(item) {
      var _this3 = this;
      switch (item.id) {
        case MORE_OPTIONS_IDENTIFIER.WRITE_OFF:
          this.openWriteOffPopup();
          break;
        case MORE_OPTIONS_IDENTIFIER.PRINT:
          this.openPrinterFriendly();
          break;
        case MORE_OPTIONS_IDENTIFIER.APPLY_CREDIT:
          this.openTransactionLevelCreditModal();
          break;
        case MORE_OPTIONS_IDENTIFIER.EMAIL:
          this.openEmailDialog();
          break;
        case MENU_ITEMS.RETRY_ACTIVATION_PAYMENT:
          this.prepareRetryActivationPaymentData();
          var _this$transactionDeta = this.transactionDetailsForRetryPayment,
            subscriberPaymentInstrument = _this$transactionDeta.subscriberPaymentInstrument,
            _transactionDetails = _objectWithoutProperties(_this$transactionDeta, _excluded);
          this.actions.stateGo(RETRY_ACTIVATION_PAYMENT_STATE_REDIRECT, {
            customerId: this.state.currentCustomerId,
            transactionDetailsForRetryPayment: JSON.stringify(_objectSpread(_objectSpread({}, _transactionDetails), {}, {
              subscriberPaymentInstrumentId: subscriberPaymentInstrument.Id
            }))
          });
          break;
        case MENU_ITEMS.RETRY_PAYMENT:
          {
            var lockerItemIds = pluck('LockerItemId', this.state.currentTransactionDetails.PurchaseOrder.Items);
            this.actions.renewOffCycleCharges(this.state.currentCustomerId, lockerItemIds).then(function () {
              _this3.uiNotificationService.success(i18n.translate(_this3.CustomerLocaleKeys.MAKE_PAYMENT.PAYMENT_SUCCESSFUL));
            }).catch(function (error) {
              _this3.uiNotificationService.transientError(error.translatedMessage);
            });
            break;
          }
        default:
          break;
      }
    }
  }, {
    key: "moreOptions",
    value: function moreOptions() {
      this.moreOptionsArray = [];
      this.hasInsertedPrintTransaction = false;
      this.hasInsertedEmailTransaction = false;
      this.hasInsertedWriteOff = false;
      this.hasInsertedApplyCredit = false;
      this.hasRetryActivationPayment = false;
      if (this.state.isDisplayTransactionEmailAndPrintEnabled && !this.hasInsertedPrintTransaction && hasAccess(this.state.userSecurityAttributes, SEND_TRANSACTION_RECEIPT_ACCESS)) {
        this.moreOptionsArray.push({
          title: i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.PRINT_TRANSACTION),
          id: MORE_OPTIONS_IDENTIFIER.PRINT
        });
        this.hasInsertedPrintTransaction = true;
      }
      if (this.state.isDisplayTransactionEmailAndPrintEnabled && this.state.isPIIDataAccessEnabled && !this.hasInsertedEmailTransaction && hasAccess(this.state.userSecurityAttributes, SEND_TRANSACTION_RECEIPT_ACCESS)) {
        this.moreOptionsArray.push({
          title: i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.EMAIL_TRANSACTION),
          id: MORE_OPTIONS_IDENTIFIER.EMAIL
        });
        this.hasInsertedEmailTransaction = true;
      }
      if (this.canIssueWriteOff && !this.hasInsertedWriteOff) {
        this.moreOptionsArray.push({
          title: i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.WRITE_OFF),
          id: MORE_OPTIONS_IDENTIFIER.WRITE_OFF
        });
        this.hasInsertedWriteOff = true;
      }
      if (this.canApplyCredit && !this.hasInsertedApplyCredit && !this.isLockbox) {
        this.moreOptionsArray.push({
          title: i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.APPLY_CREDIT),
          id: MORE_OPTIONS_IDENTIFIER.APPLY_CREDIT
        });
        this.hasInsertedApplyCredit = true;
      }
      if (this.isGracePeriodPaymentFailure) {
        this.moreOptionsArray.push({
          title: i18n.translate(CustomerLocaleKeys.CUSTOMER_DASHBOARD.RETRY_PAYMENT),
          id: MENU_ITEMS.RETRY_PAYMENT
        }, {
          title: i18n.translate(CustomerLocaleKeys.CUSTOMER_DASHBOARD.MANAGE_PAYMENT_INSTRUMENT),
          subitems: [{
            id: MENU_ITEMS.EDIT_PAYMENT_INSTRUMENT,
            title: i18n.translate(CustomerLocaleKeys.CUSTOMER_DASHBOARD.EDIT_EXISTING)
          }, {
            id: MENU_ITEMS.CHANGE_PAYMENT_INSTRUMENT,
            title: i18n.translate(CustomerLocaleKeys.CUSTOMER_DASHBOARD.CHANGE)
          }, {
            id: MENU_ITEMS.ADD_PAYMENT_INSTRUMENT,
            title: i18n.translate(CustomerLocaleKeys.CUSTOMER_DASHBOARD.ADD_NEW)
          }]
        });
        this.isGracePeriodPaymentFailure = false;
      }

      /* More Action Items has two Retry Payment options.
          1. Off Cycle Renewal
          2. Retry Payment will appear when ChargeTiming: 2 (Activation)
          As checked both condition will not appear together.
      */
      if (!this.hasRetryActivationPayment && this.canRetryActivationPayment) {
        this.moreOptionsArray.push({
          title: i18n.translate(CustomerLocaleKeys.CUSTOMER_DASHBOARD.RETRY_PAYMENT),
          id: MENU_ITEMS.RETRY_ACTIVATION_PAYMENT
        });
        this.hasRetryActivationPayment = true;
      }
    }
  }, {
    key: "purchaseOrderColumnDefs",
    get: function get() {
      return [{
        field: 'date',
        cellTemplate: require('./cellTemplates/purchaseOrder/date.html'),
        displayName: i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.DATE),
        minWidth: 70,
        enableColumnResizing: true,
        width: 150
      }, {
        field: 'type',
        cellTemplate: require('./cellTemplates/purchaseOrder/item.type.html'),
        displayName: i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.ITEM_TYPE),
        enableColumnResizing: true,
        minWidth: 100
      }, {
        field: 'description',
        displayName: i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.DESCRIPTION),
        enableColumnResizing: true,
        minWidth: 350,
        footerCellTemplate: require('./cellTemplates/purchaseOrder/subtotal.html')
      }, {
        field: 'externalReference',
        cellTemplate: require('./cellTemplates/purchaseOrder/external.reference.html'),
        displayName: i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.EXTERNAL_REFERENCE),
        enableColumnResizing: true,
        minWidth: 150
      }, {
        field: 'attempted',
        cellTemplate: require('./cellTemplates/purchaseOrder/attempted.html'),
        displayName: i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.ATTEMPTED_AMOUNT),
        enableColumnResizing: true,
        headerCellTemplate: RIGHT_ALIGNED_HEADER_TEMPLATE,
        width: 180,
        footerCellTemplate: require('./cellTemplates/purchaseOrder/total.attempted.html')
      }, {
        field: 'transacted',
        cellTemplate: require('./cellTemplates/purchaseOrder/transacted.html'),
        displayName: i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.TRANSACTED_AMOUNT),
        enableColumnResizing: true,
        headerCellClass: 'u-pr++',
        headerCellTemplate: RIGHT_ALIGNED_HEADER_TEMPLATE,
        width: 180,
        footerCellTemplate: require('./cellTemplates/purchaseOrder/total.transacted.html')
      }].filter(Boolean);
    }
  }, {
    key: "canIssueWriteOff",
    get: function get() {
      return hasAccess(this.state.userSecurityAttributes, ISSUE_WRITE_OFF) && path(['state', 'currentTransactionDetails', 'PurchaseOrder', 'Totals', 'TotalWriteOffableAmount'])(this);
    }
  }, {
    key: "canApplyCredit",
    get: function get() {
      return this.state.canApplyCredit && this.csrCanIssueCredit && path(['state', 'currentTransactionDetails', 'PurchaseOrder', 'Totals', 'TotalCreditableAmount'])(this);
    }
  }, {
    key: "csrCanIssueCredit",
    get: function get() {
      return getUpperLimitAccess(this.state.userSecurityAttributes, ISSUE_CREDIT_STANDARD_CURRENCY_LIMIT.id);
    }
  }, {
    key: "isLockbox",
    get: function get() {
      var lockboxPaymentData = pathOr(null, ['Items', 0, 'LockboxPaymentTransaction'], this.state.currentTransactionDetails);
      return !!lockboxPaymentData && !!lockboxPaymentData.RequestDate && !!lockboxPaymentData.ReceivedDate;
    }
  }, {
    key: "canChangePaymentInstrument",
    get: function get() {
      return hasAccess(this.state.userSecurityAttributes, ISSUE_CREDIT_TO_ALTERNATE_PAYMENT_INSTRUMENT);
    }
  }, {
    key: "goBack",
    value: function goBack() {
      // Credit / consolidated COS links navigate between transaction detail pages.
      // In that case lastRoute points at the previous transaction; always return to the list instead.
      if (this.state.lastRoute.name === TRANSACTION_DETAILS_STATE) {
        this.$state.go(this.DEFAULT_BACK_ROUTE, {
          customerId: this.state.currentCustomerId
        });
        return;
      }
      var route = this.state.lastRoute.name || this.DEFAULT_BACK_ROUTE;
      var params = this.state.lastRoute.params || {};
      this.$state.go(route, params);
    }
  }, {
    key: "openWriteOffPopup",
    value: function openWriteOffPopup() {
      this.showWriteOffPopup = true;
      this.$timeout(this.writeOffPopupApi.open);
    }
  }, {
    key: "closeWriteOffPopup",
    value: function closeWriteOffPopup() {
      this.showWriteOffPopup = false;
      this.writeOffPopupApi.close();
    }
  }, {
    key: "onSuccessfulWriteOff",
    value: function onSuccessfulWriteOff() {
      this.closeWriteOffPopup();
      this.uiNotificationService.success(i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.SUCCESSFUL_WRITE_OFF), null, {
        timeOut: NOTIFICATION_TIME_LENGTH
      });
      this.actions.stateGo(TRANSACTION_DETAILS_STATE, {
        transactionId: this.state.currentTransactionId
      }, {
        reload: true
      });
    }
  }, {
    key: "closeTransactionTypePopup",
    value: function closeTransactionTypePopup() {
      this.showTransactionTypePopup = false;
      this.transactionTypePopupApi.close();
    }
  }, {
    key: "onCloseModifyPaymentMethodPopup",
    value: function onCloseModifyPaymentMethodPopup() {
      this.isModifyPaymentMethodPopupShown = false;
      this.modifyPaymentMethodPopupApi.close();
    }
  }, {
    key: "closeChangePaymentMethodPopup",
    value: function closeChangePaymentMethodPopup() {
      this.changePaymentPopupApi.close();
      this.showChangePaymentPopup = false;
    }
  }, {
    key: "onSuccessModifyPaymentMethodPopup",
    value: function onSuccessModifyPaymentMethodPopup() {
      var _this4 = this;
      this.actions.retrieveTransaction(this.state.currentTransactionId, this.state.currentCustomerId, this.state.isDbss).catch(function (error) {
        _this4.uiNotificationService.transientError(error.translatedMessage);
      }).finally(function () {
        _this4.onCloseModifyPaymentMethodPopup();
        _this4.moreOptions();
      });
    }
  }, {
    key: "onChangePaymentMethod",
    value: function onChangePaymentMethod(paymentInstrument) {
      var _this5 = this;
      var paymentInstrumentId = paymentInstrument.Default ? null : paymentInstrument.Id;
      var offeringInstanceId = pathOr(null, ['PurchaseOrder', 'Items', 0, 'PurchaseInformation', 'OfferingInstanceId'], this.state.currentTransactionDetails);
      this.actions.updateOfferingInstancePaymentInstrument(this.state.currentCustomerId, offeringInstanceId, paymentInstrumentId).then(function () {
        _this5.uiNotificationService.success(i18n.translate(_this5.CustomerLocaleKeys.MAKE_PAYMENT.EDIT_INSTRUMENT_SUCCESS));
        _this5.actions.retrieveConvergentBillerSubscriberSummary(_this5.state.currentCustomerId, true);
        _this5.actions.retrieveTransaction(_this5.state.currentTransactionId, _this5.state.currentCustomerId, _this5.state.isDbss);
      }).catch(function (error) {
        _this5.uiNotificationService.transientError(error.translatedMessage);
      }).finally(function () {
        _this5.closeChangePaymentMethodPopup();
        _this5.moreOptions();
      });
    }
  }, {
    key: "canRetryActivationPayment",
    get: function get() {
      return pathOr(null, ['ChargeTiming'], this.state.currentTransactionDetails) === CHARGE_TIMING.DUE_ON_ACTIVATION && pathOr(null, ['ResultCode'], this.state.currentTransactionDetails) !== PAYMENT_SUCCESS_RESULT_CODE && !pathOr(null, ['RetriedByTransactionId'], this.state.currentTransactionDetails) && pathOr(null, ['PurchaseOrder', 'OrderId'], this.state.currentTransactionDetails) && !!this.failedCapturedTransactionItem;
    }
  }, {
    key: "prepareRetryActivationPaymentData",
    value: function prepareRetryActivationPaymentData() {
      var offeringInstanceIds = pathOr([], ['PurchaseOrder', 'Items'], this.state.currentTransactionDetails).map(function (item) {
        return pathOr(null, ['PurchaseInformation', 'OfferingInstanceId'], item);
      });
      var offeringDetailsForOfferingInstanceId = (offeringInstanceIds === null || offeringInstanceIds === void 0 ? void 0 : offeringInstanceIds.length) > 0 ? (this.state.convergentBillerSubscriberOfferingSummaries || []).find(function (offeringSummary) {
        return offeringSummary.OfferingInstanceId === (offeringInstanceIds === null || offeringInstanceIds === void 0 ? void 0 : offeringInstanceIds[0]);
      }) : null;
      this.transactionDetailsForRetryPayment = {
        orderId: pathOr(null, ['PurchaseOrder', 'OrderId'], this.state.currentTransactionDetails),
        offeringInstanceIds: uniq(offeringInstanceIds),
        originalTransactionId: this.state.currentTransactionId,
        offeringId: pathOr(null, ['OfferingId'], offeringDetailsForOfferingInstanceId),
        orderItemIds: pluck('OrderItemId', pathOr([], ['PurchaseOrder', 'Items'], this.state.currentTransactionDetails)).map(String),
        subscriberPaymentInstrument: pathOr(null, ['PaymentInstrument'], offeringDetailsForOfferingInstanceId),
        currencyCode: pathOr(null, ['PurchaseOrder', 'Currency'], this.state.currentTransactionDetails),
        amount: pathOr(null, ['Amount'], this.failedCapturedTransactionItem)
      };
    }
  }, {
    key: "openTransactionTypePopup",
    value: function openTransactionTypePopup(selectedTransaction) {
      this.selectedTransaction = selectedTransaction;
      this.selectedTransactionPaymentInstrument = this.state.currentTransactionDetails.paymentAmounts && this.state.currentTransactionDetails.paymentAmounts.find(function (_ref8) {
        var Id = _ref8.PaymentInstrument.Id;
        return Id === selectedTransaction.PaymentInstrumentId;
      }).PaymentInstrument;
      this.showTransactionTypePopup = true;
      this.$timeout(this.transactionTypePopupApi.open);
    }
  }, {
    key: "openPrinterFriendly",
    value: function openPrinterFriendly() {
      var invoiceWindow = this.$window.open('', '_blank');
      if (invoiceWindow) {
        invoiceWindow.document.write(transactionDetails(this.state.printTransactionDetails));
      } else {
        this.uiNotificationService.error(i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.UNABLE_TO_OPEN_WINDOW), {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
      }
    }
  }, {
    key: "openCreditModal",
    value: function openCreditModal() {
      this.showCreditModal = true;
      this.$timeout(this.applyCreditModalApi.open);
    }
  }, {
    key: "lockBoxApiData",
    value: function lockBoxApiData() {
      return {
        AccountNumber: pathOr(null, ['currentAccountSummary', 'AccountNumber'], this.state)
      };
    }
  }, {
    key: "creditModalConfig",
    value: function creditModalConfig(apiData) {
      var _this$state$currentTr11, _this$state$currentTr12;
      this.showCreditRefundModal = true;
      this.additionalApiData = this.isLockbox ? this.lockBoxApiData() : apiData || {
        PurchaseOrderId: (_this$state$currentTr11 = this.state.currentTransactionDetails) === null || _this$state$currentTr11 === void 0 ? void 0 : (_this$state$currentTr12 = _this$state$currentTr11.PurchaseOrder) === null || _this$state$currentTr12 === void 0 ? void 0 : _this$state$currentTr12.Id
      };
    }
  }, {
    key: "openCreditRefundModal",
    value: function openCreditRefundModal() {
      var _this6 = this;
      var apiData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (this.canChangePaymentInstrument) {
        this.actions.retrieveWallet({
          customerId: this.state.currentCustomerId
        }).then(function () {
          _this6.creditModalConfig(apiData);
          _this6.moreOptions();
        });
      } else {
        this.creditModalConfig(apiData);
      }
    }
  }, {
    key: "openPurchaseOrderItemLevelCreditModal",
    value: function openPurchaseOrderItemLevelCreditModal(item) {
      var _this$state$currentTr13, _this$state$currentTr14, _this$state$currentTr15, _this$state$currentTr16;
      var additionalApiData = {
        PurchaseOrderId: (_this$state$currentTr13 = this.state.currentTransactionDetails) === null || _this$state$currentTr13 === void 0 ? void 0 : (_this$state$currentTr14 = _this$state$currentTr13.PurchaseOrder) === null || _this$state$currentTr14 === void 0 ? void 0 : _this$state$currentTr14.Id,
        PurchaseOrderItemId: item.id
      };
      this.maxCreditAmount = item.creditableAmount;
      this.currencyCode = (_this$state$currentTr15 = this.state.currentTransactionDetails) === null || _this$state$currentTr15 === void 0 ? void 0 : (_this$state$currentTr16 = _this$state$currentTr15.PurchaseOrder) === null || _this$state$currentTr16 === void 0 ? void 0 : _this$state$currentTr16.Currency;
      this.openCreditRefundModal(additionalApiData);
    }
  }, {
    key: "openTransactionLevelCreditModal",
    value: function openTransactionLevelCreditModal() {
      var _this$state$currentTr17, _this$state$currentTr18, _this$state$currentTr19, _this$state$currentTr20, _this$state$currentTr21, _this$state$currentTr22, _this$state$currentTr23;
      this.additionalApiData = {
        PurchaseOrderId: (_this$state$currentTr17 = this.state.currentTransactionDetails) === null || _this$state$currentTr17 === void 0 ? void 0 : (_this$state$currentTr18 = _this$state$currentTr17.PurchaseOrder) === null || _this$state$currentTr18 === void 0 ? void 0 : _this$state$currentTr18.Id
      };
      this.maxCreditAmount = (_this$state$currentTr19 = this.state.currentTransactionDetails) === null || _this$state$currentTr19 === void 0 ? void 0 : (_this$state$currentTr20 = _this$state$currentTr19.PurchaseOrder) === null || _this$state$currentTr20 === void 0 ? void 0 : (_this$state$currentTr21 = _this$state$currentTr20.Totals) === null || _this$state$currentTr21 === void 0 ? void 0 : _this$state$currentTr21.TotalCreditableAmount;
      this.currencyCode = (_this$state$currentTr22 = this.state.currentTransactionDetails) === null || _this$state$currentTr22 === void 0 ? void 0 : (_this$state$currentTr23 = _this$state$currentTr22.PurchaseOrder) === null || _this$state$currentTr23 === void 0 ? void 0 : _this$state$currentTr23.Currency;
      this.openCreditRefundModal();
    }
  }, {
    key: "closeCreditModal",
    value: function closeCreditModal() {
      this.showCreditModal = false;
      this.applyCreditModalApi.close();
    }
  }, {
    key: "closeCreditRefundModal",
    value: function closeCreditRefundModal() {
      this.showCreditRefundModal = false;
    }
  }, {
    key: "onCreditSubmission",
    value: function onCreditSubmission() {
      this.uiNotificationService.success(i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.SUCCESSFUL_CREDIT), null, {
        timeOut: NOTIFICATION_TIME_LENGTH
      });
      this.actions.stateGo(TRANSACTION_DETAILS_STATE, {
        transactionId: this.state.currentTransactionId
      }, {
        reload: true
      });
      this.closeCreditModal();
    }
  }, {
    key: "openEmailDialog",
    value: function openEmailDialog() {
      this.showEmailDialog = true;
      this.$timeout(this.emailPopupApi.open);
    }
  }, {
    key: "closeEmailDialog",
    value: function closeEmailDialog() {
      this.showEmailDialog = false;
      this.emailPopupApi.close();
    }
  }, {
    key: "getSubcriberPaymentInstrument",
    value: function getSubcriberPaymentInstrument() {
      var revenuePaymentInstrumentId = pathOr(null, ['PaymentAmounts', 0, 'PaymentInstrument'], this.state.currentTransactionDetails);
      var subcriberPaymentInstrumentIdObj = this.state.currentTransactionDetails.Items.find(function (item) {
        return item.PaymentInstrumentId === revenuePaymentInstrumentId.Id;
      });
      return this.state.ewalletPaymentInstruments.find(function (paymentInstrument) {
        return paymentInstrument.Id === subcriberPaymentInstrumentIdObj.SubscriberPaymentInstrumentId;
      });
    }
  }, {
    key: "openPaymentMethodPopup",
    value: function openPaymentMethodPopup() {
      var _this7 = this;
      var isEdit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.isEditingPaymentInstrument = isEdit;
      this.modalPaymentMethod = clone(isEdit ? this.getSubcriberPaymentInstrument() : BLANK_PAYMENT_INSTRUMENT);
      this.isModifyPaymentMethodPopupShown = true;
      this.$timeout(function () {
        _this7.modifyPaymentMethodPopupApi.open();
      });
    }
  }, {
    key: "openChangePaymentMethodPopup",
    value: function openChangePaymentMethodPopup() {
      var _this8 = this;
      var offeringId = pathOr(null, ['PurchaseOrder', 'Items', 0, 'PurchaseInformation', 'OfferingId'], this.state.currentTransactionDetails);
      var changePopUpPaymentInstrument = this.state.convergentBillerSubscriberOfferingSummaries ? this.state.convergentBillerSubscriberOfferingSummaries.find(function (offerSummary) {
        return offerSummary.OfferingId === offeringId;
      }) : null;
      this.changePopUpPaymentInstrument = changePopUpPaymentInstrument.PaymentInstrument;
      this.actions.retrieveWallet({
        customerId: this.state.currentCustomerId
      }).then(function () {
        _this8.showChangePaymentPopup = true;
        _this8.$timeout(function () {
          _this8.changePaymentPopupApi.open();
        });
        _this8.moreOptions();
      });
    }
  }, {
    key: "onEmailSuccess",
    value: function onEmailSuccess() {
      this.uiNotificationService.success(i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.SUCCESSFUL_EMAIL), null, {
        timeOut: NOTIFICATION_TIME_LENGTH
      });
      this.closeEmailDialog();
    }
  }, {
    key: "onBannerClose",
    value: function onBannerClose() {
      this.shouldShowBackBanner = false;
    }
  }]);
}();
export default {
  template: require('./detail.html'),
  controller: DetailController,
  controllerAs: 'TransactionDetail'
};